import { Avatar, IconButton } from "@mui/material";
import Link from "components/Link";
import React, { FC, useEffect, useState } from "react";
import { CiSearch } from "react-icons/ci";
import { get } from "services/axios";
import HeaderImage from "../../assets/images/Screenshot 2024-07-25 230828.png";
import _logo from "../../assets/images/logo.png";
import AvatarDropdown from "./AvatarDropdown";
import SearchModal from "./SearchModal";

export interface MainNav2LoggedProps {}

const MainNav2Logged: FC<MainNav2LoggedProps> = () => {
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const handleKeydown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.key.toLowerCase() === "f") {
        e.preventDefault();
        setOpen((prevOpen) => !prevOpen);
      }
    };

    window.addEventListener("keydown", handleKeydown);
    return () => {
      window.removeEventListener("keydown", handleKeydown);
    };
  }, []);

  const [title, setTitle] = useState("");
  const [logo, setLogo] = useState("");

  const getSiteConfigurations = async () => {
    try {
      const response = await get("/admin-panel/site-info");
      console.log(response.data);
      setSiteConfigurations(response.data);
    } catch (error) {
      console.error("Error getting site configuration:", error);
    }
  };

  const setSiteConfigurations = (data: any) => {
    if (data.name) {
      document.title = data.name;
    }

    setTitle(data.name);
    setLogo(data.logo);
  };

  // useEffect(() => {
  //   getSiteConfigurations();
  // }, []);

  const renderContent = () => {
    return (
      <div className="h-20 flex justify-between">
        {/* <div className="flex items-center lg:hidden flex-1">
          <MenuBar />
        </div> */}
        {/* {logo && ( */}
        <div className="lg:flex-1 flex items-center">
          <Link
            href="/"
            className="ttnc-logo inline-block text-primary-6000 flex-shrink-0"
          >
            <Avatar
              alt="Remy Sharp"
              sx={{ width: 80, height: 80, }}
              src={_logo}
            />
          </Link>
        </div>
        {/* )} */}
        <div className="flex-1 flex items-center justify-end text-slate-700 dark:text-slate-100">
          <IconButton aria-label="search" onClick={handleOpen}>
            <CiSearch size={25} />
          </IconButton>
          <SearchModal onClose={handleClose} open={open} />
          {/* <NotifyDropdown /> */}
          <AvatarDropdown />
        </div>
      </div>
    );
  };

  return (
    <div className="nc-MainNav2Logged relative z-10 bg-white dark:bg-neutral-900 border-b border-slate-100 dark:border-slate-700">
      <div className="container ">{renderContent()}</div>
    </div>
  );
};

export default React.memo(MainNav2Logged);
